import React, { useState } from 'react';

const inputStyle = { width: '100%', background: 'rgba(8,8,8,0.5)', border: '1px solid rgba(245,240,232,0.12)', color: 'var(--white)', padding: '14px 16px', fontFamily: 'var(--font-body)', fontSize: 14, outline: 'none', transition: 'border-color 0.3s' };
const labelStyle = { display: 'block', fontSize: 10, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.45)', marginBottom: 8 };

function scrollTo(id) { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); }

export default function Register() {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', city: '', heardFrom: '', registerAs: '', 'bot-field': '' });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(null);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = new URLSearchParams({ 'form-name': 'register', ...form });
    await fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
    setSubmitted(true);
  };

  const iStyle = (name) => ({ ...inputStyle, borderColor: focused === name ? 'var(--ember)' : 'rgba(245,240,232,0.12)' });

  return (
    <section id="register" style={{ padding: '120px 64px', background: 'linear-gradient(135deg, var(--ash) 0%, rgba(200,68,10,0.06) 100%)', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', fontFamily: 'var(--font-display)', fontSize: 'clamp(160px,25vw,300px)', color: 'rgba(200,68,10,0.03)', right: -20, top: '50%', transform: 'translateY(-50%)', letterSpacing: '0.05em', pointerEvents: 'none', whiteSpace: 'nowrap' }}>REVIVE</div>
      <style>{`
        @media(max-width:900px){ #register{padding:80px 24px!important;} .register-grid{grid-template-columns:1fr!important; gap:48px!important;} .form-row{grid-template-columns:1fr!important;} }
      `}</style>

      <div className="register-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80, alignItems: 'start', position: 'relative', zIndex: 1 }}>
        <div>
          <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>Secure Your Spot</p>
          <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 24 }}>
            REGISTER<br />FOR FREE
          </h2>
          <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 32px' }} />
          <p className="reveal" style={{ fontFamily: 'var(--font-serif)', fontSize: 18, lineHeight: 1.8, color: 'rgba(245,240,232,0.55)', maxWidth: 420 }}>
            REVIVE is completely free. Register to receive your city's event details, location, and everything you need to be there.
          </p>

          <div className="reveal" style={{ marginTop: 48 }}>
            <p style={{ fontSize: 10, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 16 }}>Also Available</p>
            {[
              { label: 'Register to Volunteer', target: 'volunteer-form' },
              { label: 'Partner With REVIVE / Give', target: 'get-involved' },
              { label: 'Bring Your Community', target: 'get-involved' },
            ].map(l => (
              <button key={l.label} onClick={() => scrollTo(l.target)}
                style={{ display: 'block', background: 'none', border: 'none', fontSize: 13, color: 'rgba(245,240,232,0.45)', letterSpacing: '0.1em', marginBottom: 14, padding: 0, textAlign: 'left', transition: 'color 0.3s' }}
                onMouseEnter={e => e.target.style.color = 'var(--white)'}
                onMouseLeave={e => e.target.style.color = 'rgba(245,240,232,0.45)'}>
                → {l.label}
              </button>
            ))}
          </div>
        </div>

        <div className="reveal">
          {!submitted ? (
            <form onSubmit={handleSubmit} name="register" data-netlify="true" netlify-honeypot="bot-field">
              <input type="hidden" name="form-name" value="register" />
              <input type="hidden" name="bot-field" value={form['bot-field']} />

              <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
                <div>
                  <label style={labelStyle}>First Name</label>
                  <input required value={form.firstName} onChange={set('firstName')} onFocus={() => setFocused('firstName')} onBlur={() => setFocused(null)} placeholder="First name" style={iStyle('firstName')} />
                </div>
                <div>
                  <label style={labelStyle}>Last Name</label>
                  <input required value={form.lastName} onChange={set('lastName')} onFocus={() => setFocused('lastName')} onBlur={() => setFocused(null)} placeholder="Last name" style={iStyle('lastName')} />
                </div>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Email Address</label>
                <input required type="email" value={form.email} onChange={set('email')} onFocus={() => setFocused('email')} onBlur={() => setFocused(null)} placeholder="your@email.com" style={iStyle('email')} />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Phone Number</label>
                <input type="tel" value={form.phone} onChange={set('phone')} onFocus={() => setFocused('phone')} onBlur={() => setFocused(null)} placeholder="+1 (000) 000-0000" style={iStyle('phone')} />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Select Your City</label>
                <select required value={form.city} onChange={set('city')} style={{ ...iStyle('city'), appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.city ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
                  <option value="" disabled>Choose a city</option>
                  {['REVIVE LA — Los Angeles, CA','REVIVE Dallas — Dallas, TX','REVIVE SF — San Francisco, CA','REVIVE Hawaii','REVIVE Louisiana','REVIVE Colorado','REVIVE Atlanta — Georgia'].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>How Did You Hear About REVIVE?</label>
                <select value={form.heardFrom} onChange={set('heardFrom')} style={{ ...iStyle('heardFrom'), appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.heardFrom ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
                  <option value="" disabled>Select one</option>
                  {['Instagram','TikTok','Facebook','A Friend / Word of Mouth','Church / Ministry','Christian Influencer','Other'].map(o => <option key={o}>{o}</option>)}
                </select>
              </div>

              <div style={{ marginBottom: 24 }}>
                <label style={labelStyle}>I Am Registering As</label>
                <select value={form.registerAs} onChange={set('registerAs')} style={{ ...iStyle('registerAs'), appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.registerAs ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
                  <option value="" disabled>Select one</option>
                  {['Attendee','Volunteer','Partner / Ministry Leader',"I'd like to bring a group"].map(o => <option key={o}>{o}</option>)}
                </select>
              </div>

              <button type="submit" style={{ width: '100%', background: 'var(--ember)', color: 'var(--white)', border: 'none', padding: '18px 32px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 500, letterSpacing: '0.25em', textTransform: 'uppercase' }}
                onMouseEnter={e => e.target.style.background = 'var(--ember-light)'}
                onMouseLeave={e => e.target.style.background = 'var(--ember)'}>
                Secure My Spot — It's Free
              </button>
            </form>
          ) : (
            <div style={{ padding: 48, border: '1px solid rgba(200,68,10,0.3)', textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 48, color: 'var(--ember)', marginBottom: 16 }}>YOU'RE IN.</div>
              <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 19, color: 'rgba(245,240,232,0.6)', marginBottom: 24 }}>Your city is waiting. We'll be in touch with all the details.</p>
              <p style={{ fontSize: 13, color: 'rgba(245,240,232,0.35)' }}>Check your inbox — and tell a friend.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
